module.exports = __webpack_public_path__ + "assets/img/pt-7a1207dd.png";